var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('video',{staticClass:"video-js vjs-default-skin",attrs:{"maxLength":"1000","id":"myVideo","playsinline":""}})}
var staticRenderFns = []

export { render, staticRenderFns }